"use client"

import { Text } from "@/elements"
import { useTabs } from "./useTabs"

export type TabType = {
  id: string
  title: string
}

interface TabsProps {
  tabs: TabType[]
  defaultTab: TabType
  onTabClicked: (tab: TabType) => void
}

const Tab: React.FC<{
  tab: TabType
  isActive: boolean
  onClick: () => void
}> = ({ tab, isActive, onClick }) => {
  return (
    <div
      className={`w-full cursor-pointer py-2 text-center ${isActive ? "text-primary-500 border-b-2 border-fg-2" : "border-b-2 border-bg-2"}`}
      onClick={onClick}>
      <Text variant="body1">{tab.title}</Text>
    </div>
  )
}

export const Tabs: React.FC<TabsProps> = ({ tabs, defaultTab, onTabClicked }) => {
  const { selectedTab, setActiveTab } = useTabs({ tabs, defaultTab })

  const onClick = (tab: TabType) => {
    setActiveTab(tab.id)
    onTabClicked(tab)
  }

  return (
    <div className="no-wrap flex flex-row">
      {tabs.map(tab => (
        <div className="flex flex-auto" key={tab.id}>
          <Tab tab={tab} isActive={tab.id === selectedTab?.id} onClick={() => onClick(tab)} />
        </div>
      ))}
    </div>
  )
}
